<template>
  <i-select :value="value" class="select-contact-method-type" v-on="$listeners">
    <i-option
      v-for="(title, key) in $t('pbx.contact-method.label')"
      :key="key"
      :value="key"
      :label="title"
    >
      <contact-method-type-icon :type="key" class="select-contact-method-type__icon" />
      <span>{{ title }}</span>
    </i-option>
  </i-select>
</template>

<script>
  import ContactMethodTypeIcon from '@pbx/components/contact-methods/_fragments/label/icon';

  export default {
    components: { ContactMethodTypeIcon },
    props: {
      value: {
        type: [String, Number, null],
        default: null
      }
    }
  };
</script>

<style lang="scss">
  .select-contact-method-type {
    .ivu-select-item {
      display: flex;
      align-items: center;
    }

    &__icon {
      margin-right: 15px;
    }
  }
</style>
